export const IDENTITY_SDK_RESET_COOKIE = "identitySdkResetRequired";
export const GTM_ID = "GTM-NR75XMD";
